module.exports = {
	"library.navbar.sign_up": "Εγγραφείτε",
	"library.navbar.sign_in": "Σύνδεση",
	"library.navbar.sign_out": "Αποσυνδέση",
	"library.navbar.help": "Βοήθεια",
	"library.navbar.search_for_events": "Αναζήτηση εκδήλωσης",
	"library.navbar.enter_location": "Εισαγάγετε την τοποθεσία",
	"library.navbar.find_events": "Εύρεση εκδήλωσης",
	"library.navbar.create_event": "δημιουργία εκδήλωσης",
	"library.navbar.host_events": "Διοργάνωση εκδήλωσης",
	"library.navbar.dashboard": "Ταμπλό",
	"library.navbar.my_events": "Εκδηλώσεις που φιλοξενείτε",
	"library.navbar.my_tickets": "Τα εισιτήριά σας",
	"library.navbar.admin_panel": "Πίνακας Διαχειριστή",
	"library.navbar.profile": "Προφίλ",
	"library.navbar.messages": "Μηνύματα",
	"library.navbar.settings": "Ρυθμίσεις",
	"library.navbar.search_cities": "Αναζήτηση πόλεων",
	"library.navbar.help_center": "Κέντρο βοηθείας",
	"library.navbar.cant_find_tickets": "Where are my tickets?",
	"library.navbar.contact_organizer": "Contact the event organizer",
	"library.navbar.can_refund": "Μπορώ να επιστρέψω;"
};


//////////////////
// WEBPACK FOOTER
// ./~/@uniiverse/library/components/navbar/translations/el.json
// module id = 1511
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14 15 16